export default __webpack_public_path__ + "static/media/printer.3eea2831.png";